import { useTranslation } from "react-i18next";

interface ErrorStateProps {
  error: string;
}

export function ErrorState({ error }: ErrorStateProps) {
  const { t } = useTranslation();

  return (
    <div className="p-4">
      <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
        <strong className="font-bold">{t("knowledgeBase.error")}</strong>
        <span className="block sm:inline"> {error}</span>
      </div>
    </div>
  );
}
